import { Component, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { AnessaTranslationService } from '../../../../../helper/translation/anessa-translation.service';
import { ConfiguredToastrService } from '../../../../../helper/toastr/configured-toastr.service';
import { DeactivationDialogService } from '../../../../../helper/can-deactivate/deactivation-dialog.service';
import { ProjectChecklistColumn } from '../../../../../models/project/project-info.model';
import Utils from '../../../../../util';
import { ProjectChecklistService } from '../../checklist.service';
import { UserpilotReloader } from '../../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-edit-column-dialog',
  templateUrl: './edit-column-dialog.component.html',
  styleUrls: [
    './edit-column-dialog.component.scss',
  ]
})
export class EditColumnDialogComponent extends UserpilotReloader{

  @ViewChild('columnForm') form: NgForm;

  trigger: string;
  newItemName: string;

  column: ProjectChecklistColumn;

  isEdit = false;
  isColour = false;
  showClearName = false;
  showLock = true;

  constructor(
    private dialogRef: MatDialogRef<EditColumnDialogComponent>,
    private deactivationDialogService: DeactivationDialogService,
    private toastrService: ConfiguredToastrService,
    private checklistService: ProjectChecklistService,
    private translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) private data: { column: ProjectChecklistColumn, names: string[], showLock: boolean },
  ) {
    super();
    if (this.data.column != null) {
      this.isEdit = true;
      this.column = this.data.column;
    } else {
      this.column = new ProjectChecklistColumn();
    }
    if (!this.column.align) this.column.align = 'center';
    if (typeof data.showLock === 'boolean') this.showLock = data.showLock;
    this.isColour = this.column.acceptedItems.some(item => item.startsWith('#'));

    this.trigger = this.translationService.getCurrentLang();

    this.dialogRef.backdropClick().subscribe(() => {
      if (this.form.dirty) {
        this.deactivationDialogService.confirm(this.translationService.get('PROJECT.COMMON.DEACTIVATE_CONFIRM'))
          .pipe(take(1)).subscribe(result => {
            if (result) {
              this.dialogRef.close();
            }
          });
      } else {
        this.dialogRef.close();
      }
    });
  }

  isColourInput() {
    return this.isColour || this.column.acceptedItems.some(item => item.startsWith('#'));
  }

  isColourHexCode(value: string) {
    if (value != null && value.startsWith('#')) {
      return true;
    }
    return false;
  }

  getPaletteTooltip() {
    if (this.isColour) {
      return 'PROJECT.PROJECT_INFO.CHECKLIST.NO_COLOUR_ITEMS';
    } else {
      return 'PROJECT.PROJECT_INFO.CHECKLIST.USE_COLOUR_ITEMS';
    }
  }

  onToggleColours() {
    this.isColour = !this.isColour;
    this.column.acceptedItems = [];
    if (this.isColour) {
      this.newItemName = null;
    } else {
      this.newItemName = '';
    }
  }

  onAdd() {
    if (Utils.nameIsUnique(this.newItemName, this.column.acceptedItems.map(item => Utils.stringToNameObject(item)))) {
      this.column.acceptedItems.push(this.newItemName);
      this.newItemName = null;
    } else {
      this.toastrService.error(this.translationService.get('PROJECT.PROJECT_INFO.CHECKLIST.ENTRY_EXISTS'));
    }
  }

  onRemove(name: string) {
    const index = this.column.acceptedItems.findIndex(itemName => itemName === name);
    this.column.acceptedItems.splice(index, 1);
  }

  onSave() {
    if (Utils.nameIsUnique(this.column.name, this.data.names)) {
      this.dialogRef.close(this.column);
    } else {
      this.toastrService.error(this.translationService.get('PROJECT.PROJECT_INFO.CHECKLIST.NAME_EXISTS'));
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
